import { jsx as _jsx } from "react/jsx-runtime";
// =============================================================================
// Copyright   : 2018 semantics GmbH
// Date        : $Date: 2026-03-13 15:47:48 +0100 (Fri, 13 Mar 2026) $
// Author      : Dirk Rothe, Tobias Schwarzkopf
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 161511 $
// Purpose     : some examples and some whiteboard space for /test/whiteboard
// =============================================================================
// ---Third-party imports
import clsx from 'clsx';
import React, { useState, useEffect, useMemo } from 'react';
// ---Local imports
import S from './index.css';
// ---Exports
export { TextTicker } from './textTicker';
export { TextTickerSelection } from './textTickerPicker';
export { AudioTicker, AudioWaves } from './audioticker';
export { Showcase } from './showcase';
export { SlideIndicator } from './slideIndicator';
export { AiPrompt, AiImage } from './ai';
export { PageViewer } from './pageViewer';
export { Modal } from './modal';
export { MediaPlayer } from './mediaplayer';
export const GhostText = ({ className, fontSize = '1rem', lines = 8, style })=>{
    let lineStyles = useMemo(()=>{
        return Array.from({
            length: lines
        }).map(()=>({
                width: `${Math.floor(Math.random() * 51) + 50}%`,
                height: fontSize
            }));
    }, [
        lines,
        fontSize
    ]);
    return /*#__PURE__*/ _jsx("div", {
        style: style,
        className: clsx(className, S.placeholder),
        children: lineStyles.map((style, i)=>/*#__PURE__*/ _jsx("div", {
                className: S.line,
                style: style
            }, i))
    });
};
export const GhostImage = ({ width, height, className, style })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: clsx(S.placeholder, S.image, className),
        style: {
            width,
            height,
            ...style
        }
    });
};
